import Image from "antd/es/image";
import React from "react";
import {useTranslation} from "react-i18next";

export default (prop) => {

    // const {t} = useTranslation()

    // if (prop.type === 'hero') {
    //     console.log(1)
    //     return <Image alt={t(`heroName.${prop.name}`)} src={`/img/${prop.type}/${prop.name}.jpg`} preview={false} width={prop.size} height={prop.size} />
    // }

    return <Image style={prop.style} src={`/img/${prop.type}/${prop.name}.jpg`} preview={false} width={prop.size} height={prop.size} />

}
